import { CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AppRoutes } from '@fitup-monorepo/routes/lib/app-routes';
import { redactUrl } from '../util/redact.util';

/**
 * Catch-all for URLs no route matches (e.g. deep links from newer app versions). Logs the URL, so unmatched links
 * stay visible in the logs, and redirects to the root route instead of failing the navigation.
 */
export const unknownRouteGuard: CanActivateFn = (_route, state: RouterStateSnapshot): UrlTree => {
  console.warn('No route matches', redactUrl(state.url), '- redirecting to', AppRoutes.ROOT);
  return inject(Router).parseUrl(AppRoutes.ROOT);
};
